import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String, resetDelay: { type: Number, default: 2000 } };
  static targets = ["copyLabel", "copiedLabel"];

  connect() {
    this.resetTimer = null;
    this.showDefaultLabel();
  }

  disconnect() {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
    }
  }

  async copy(event) {
    event.preventDefault();

    let copied = false;
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(this.urlValue);
        copied = true;
      } catch (_err) {
        // fall through to legacy copy
      }
    }

    if (!copied) {
      try {
        this.legacyCopy(this.urlValue);
        copied = true;
      } catch (err) {
        console.error("share: copy failed", err);
      }
    }

    if (copied) {
      this.showCopiedLabel();
    }

    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
    }
    this.resetTimer = setTimeout(
      () => this.showDefaultLabel(),
      this.resetDelayValue,
    );
  }

  legacyCopy(text) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }

  showDefaultLabel() {
    if (this.hasCopyLabelTarget) this.copyLabelTarget.hidden = false;
    if (this.hasCopiedLabelTarget) this.copiedLabelTarget.hidden = true;
  }

  showCopiedLabel() {
    if (this.hasCopyLabelTarget) this.copyLabelTarget.hidden = true;
    if (this.hasCopiedLabelTarget) this.copiedLabelTarget.hidden = false;
  }
}
